import { createPanelController } from '../shared/ui-panel-base.js';
import { getProfiles, setProfiles } from '../state-manager.js';
import { loadClientProfiles, updateClientProfiles } from '../requests/profiles.js';
import { closePanel } from '../shared/ui-panel-controller.js';

let localProfiles = []; // Local working copy of profiles

export const editProfilePanel = createPanelController('settings-profile-edit', {
  onOpen: () => {
    console.log('[ProfileEditPanel] Opening profile edit panel');
    // hydrate list, reset form, etc.
    localProfiles = structuredClone(getProfiles()); // deep clone to detach from state
    renderProfileList();
  },
  onClose: () => {
    document.getElementById('settings-profile-edit-list').innerHTML = '';
    console.log('[ProfileEditPanel] Closing profile edit panel');
  },
});

function renderProfileList() {
  const ul = document.getElementById('settings-profile-edit-list');
  ul.innerHTML = '';

  localProfiles.forEach(profile => {
    const li = document.createElement('li');
    li.className = 'list-item';
    li.innerHTML = `
      <input name="pname" type="text" class="name-input" value="${profile.name}" />
      <input name="pnorm" type="number" class="norm-input" value="${profile.daily_norm}" />
      <button id="profile-lock" class="lock-toggle">${profile.active ? '✅' : '❎'}</button>
    `;
    
    const nameInput = li.querySelector('.name-input');
    nameInput.addEventListener('input', () => {
      profile.name = nameInput.value;
    });

    const normInput = li.querySelector('.norm-input');
    normInput.addEventListener('input', () => {
      profile.daily_norm = parseInt(normInput.value);
    });

    const lockToggle = li.querySelector('.lock-toggle');
    lockToggle.addEventListener('click', () => {
      profile.active = !profile.active;
      lockToggle.textContent = profile.active ? '✅' : '❎';
    });

    li.dataset.profileId = profile.id;
    ul.appendChild(li);
    // Hide toogle button, when only one pet in the list 
    if (localProfiles.length < 2) {
      const btn = document.getElementById("profile-lock");
      btn.classList.add('hidden');
    }
  });
}

document.getElementById('settings-update-profiles-btn')?.addEventListener('click', async () => {
  try {
    localProfiles = localProfiles.map(p => ({
      id: p.id,
      name: p.name,
      daily_norm: p.daily_norm, // Ensure it's a number
      active: p.active ? 1 : 0,
      created_at: p.created_at || '',
    }));
    
    await updateClientProfiles(localProfiles); // POST to /api/profiles/batch-update
    const updated = await loadClientProfiles(); // re-fetch after update
    setProfiles(updated);
    editProfilePanel.close(); // close editor
  } catch (err) {
    console.error('Failed to update profiles:', err);
    alert('Update failed.');
  }
});

document.querySelector('#settings-profile-edit-sheet .back-btn')?.addEventListener('click', () => {
  console.log('[ProfileEditPanel] Back to settings from profile edit panel');
  closePanel('settings-profile-edit'); // Will automatically restore previous panel (e.g. settings)
});  
